import React, { FC } from 'react'
import LogoTransfix from 'transfix-ui/components/LogoTransfix'
import { Link } from 'transfix-ui/core'
import Box from 'transfix-ui/core/Box'
import Typography from 'transfix-ui/core/Typography'
import { ClockAlertOutlineIcon } from 'transfix-icons'
import { brandColors } from 'transfix-ui'
import { useTextStyles } from './DriverValidationPage'

export const DriverValidationExpiredPage: FC = () => {
  const classes = useTextStyles()

  return (
    <Box display='flex' flexDirection='column' alignItems='center' paddingX='32px'>
      <Box marginTop='32px' marginBottom='112px'>
        <LogoTransfix width={130} />
      </Box>
      <Box alignItems='center'>
        <Box
          width='80px'
          height='80px'
          bgcolor={brandColors.warning0}
          borderRadius='20px'
          marginBottom='16px'
          padding='16px'>
          <ClockAlertOutlineIcon color='warning1' size='xxlarge' />
        </Box>
      </Box>
      <Box marginBottom='16px'>
        <Typography variant='subtitle1' className={classes.subtitleOne} align='center'>
          This link is no longer active
        </Typography>
        <Box height='4px' />
        <Typography variant='body2' className={classes.bodyTwo} align='center'>
          You were either unassigned from this load or the load has already been delivered. If you
          believe there is a mistake,{' '}
          <Link href='tel:6469484480'>
            <b>contact Transfix.</b>
          </Link>
        </Typography>
      </Box>
    </Box>
  )
}
